export default "__VITE_ASSET__C8G5$oxq__"